module.exports = __webpack_public_path__ + "img/main.9139f3ab.png";